import { Api } from '.';
import axios from 'axios';
import {
  cleanLocalStorage,
  errorToast,
  getJWTToken,
  getLocalStorageItem,
  setLocalStorageItem
} from '../utils/helper';
import { AI_BASE_URL } from '../core/env.configs';

const BASE_URL = AI_BASE_URL || 'https://stage-ai.shoorah.io/';

const PostApi = async (tag = '', reqBody, isHeader = false, flag = false) => {
  let flagCheck = flag
    ? 'multipart/form-data; boundary=----WebKitFormBoundaryueI4YvrqiXxUgVGA'
    : 'application/json';

  return axios
    .post(BASE_URL + tag, reqBody, {
      headers: isHeader
        ? {
            'Content-Type': flagCheck,
            accept: flagCheck,
            Authorization: getJWTToken()
          }
        : {}
    })
    .then((data) => {
      return data;
    })
    .catch(async (e) => {
      ErrorHandler(e);
    });
};

const ErrorHandler = async (e) => {
  if (e.response?.data?.message) {
    if (e.response?.data?.code === 498) {
      RefreshToken();
    } else if (e.response?.data?.code === 401) {
      errorToast(e.response?.data?.message);
      cleanLocalStorage();
      window.location.href = '/login';
    } else {
      errorToast(e.response?.data?.message);
    }
  } else if (e.response?.data) {
    if (e.response?.data?.meta?.code === 498) {
      RefreshToken();
    } else if (e.response?.data?.code === 401) {
      errorToast(e.response?.data?.message);
      cleanLocalStorage();
      window.location.href = '/login';
    } else {
      errorToast(e.response?.data?.meta?.message);
    }
  } else {
    errorToast('Something went wrong');
  }
};

const RefreshToken = async () => {
  await axios
    .post(
      `${BASE_URL}company/v1/refresh-token`,
      {},
      { headers: { 'refresh-token': getLocalStorageItem('refreshToken') } }
    )
    .then(async (response) => {
      if (response.data.meta.code === 1) {
        setLocalStorageItem('token', response.data.meta.token);
        window.location.reload();
      }
    })
    .catch(async (error) => {
      if (error.response.data.code === 401) {
        await Api.logoutUser();
        cleanLocalStorage();
        window.location.href = '/login';
      } else {
        cleanLocalStorage();
        window.location.href = '/login';
      }
    });
};

export const AiApi = {
  appTutorialChat: (body) => PostApi(`app_tutorial_chat`, body, true)
};
